import { on } from 'process';
import { useState, useEffect } from 'react';
import { CHAMELEON_CACHE_v1 } from 'services/imageCache';

type Src = string | undefined;

export const useCachedResource = (
  cacheName: string = CHAMELEON_CACHE_v1,

  src: string
): Src => {
  const [$, $$] = useState<Src>(undefined);

  // i think it's these early returns that are breaking it

  // if (!('caches' in self)) {
  //   return src;
  // }

  // if (!src) {
  //   return undefined;
  // }

  // caches.has(cacheName).then(hasCacheName => {
  //   if (!hasCacheName) {
  //     console.warn(`!caches.has(${cacheName})`);
  //     return src;
  //   }
  // });

  // knowing that we're sensitive to this being an antipattern
  // we need something that at least achieves a ' cancel ' of the setState
  // since the async / fetch etc
  const setStateIfMounted = value => {
    $$(value);
  };

  useEffect(() => {
    if (!('caches' in self)) {
      $$(src);
      return;
    }

    if (!src) {
      $$(undefined);
      return;
    }

    caches.has(cacheName).then(hasCacheName => {
      if (!hasCacheName) {
        console.warn(`!caches.has(${cacheName})`);
        $$(src);
        return;
      }
    });
    //

    // carry on. . .

    caches.open(cacheName).then(cache => {
      cache
        .match(src as RequestInfo)
        .then(response => {
          if (response) {
            if (!response.ok) {
              throw Error('invalid response');
            }

            return response.blob().then(blob => {
              const objectURL = URL.createObjectURL(blob);
              $$(objectURL);
            });
          } else {
            return fetch(src as RequestInfo)
              .then(response => {
                if (!response.ok) {
                  throw Error('invalid response');
                }

                const clonedResponse = response.clone();
                cache.put(src as RequestInfo, response);
                return clonedResponse;
              })
              .then(response => {
                return response.blob();
              })
              .then(blob => {
                const objectURL = URL.createObjectURL(blob);
                $$(objectURL);
              });
          }
        })
        .catch(err => {
          console.warn(err);
          // if there IS an error we'll return src
          cache.delete(src);
          $$(src);
        });
    });

    return () => {
      //
      // need to figure some solid way to bail from the promise
    };
  }, [cacheName, src]);

  return $;
};
